import { lazy, Suspense } from 'react'

const BottomSheetImplementation = lazy(() =>
    import('./ui/BottomSheet').then((module) => ({
        default: module.BottomSheet,
    }))
)

export const BottomSheet = (props) => (
    <Suspense fallback={null}>
        <BottomSheetImplementation {...props} />
    </Suspense>
)
